import { useEffect, useState } from 'react';

const STORAGE_KEY = 'little_muslim_explorer_progress';

const defaultProgress = {
  streak: 1,
  lastActiveDate: new Date().toISOString().slice(0, 10),
  completedGames: [],
  completedAnimalGames: [],
  memorisedSurahs: [],
  listenedSurahs: [],
  completedArabic: [],
  listenedArabic: [],
  completedWords: [],
  listenedWords: [],
  completedProphets: [],
  readProphets: [],
  completedChallenges: [],
  completedTracing: [],
  favouriteNasheeds: [],
  listenedNasheeds: [],
};

function uniqueAdd(list, id) {
  return list.includes(id) ? list : [...list, id];
}

function toggle(list, id) {
  return list.includes(id) ? list.filter((item) => item !== id) : [...list, id];
}

function normaliseProgress(saved) {
  return { ...defaultProgress, ...saved };
}

export function useExplorerProgress() {
  const [progress, setProgress] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? normaliseProgress(JSON.parse(saved)) : defaultProgress;
    } catch {
      return defaultProgress;
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(progress));
  }, [progress]);

  const completeItem = (bucket, id) => {
    setProgress((current) => {
      return {
        ...current,
        [bucket]: uniqueAdd(current[bucket] || [], id),
        lastActiveDate: new Date().toISOString().slice(0, 10),
      };
    });
  };

  const toggleItem = (bucket, id) => {
    setProgress((current) => ({
      ...current,
      [bucket]: toggle(current[bucket] || [], id),
    }));
  };

  const resetProgress = () => {
    setProgress(defaultProgress);
  };

  return { progress, completeItem, toggleItem, resetProgress };
}
